<template>
  <div class="c-folder-layer__item d-flex align-items-center mt-2">
    <div class="c-folder-layer__item--preview mr-2">
      <div class="a-text-layer">
        <b-icon
          icon="textarea-t"
          class="d-block"
        />
      </div>
    </div>
    <div
      ref="tooltip"
      class="layer--item__text"
    >
      <b-tooltip
        :show.sync="isTooltipShown"
        :target="() => $refs.tooltip"
        triggers="hover"
        boundary="viewport"
        noninteractive
        :disabled="isNotTruncated(name)"
      >
        {{ name }}
      </b-tooltip>
      <EditableTextElement
        :default-value="name"
        :disabled="isSavingNodesChanges"
        :render-value="truncateFieldName"
        @change="changeLayerName"
      />
    </div>
  </div>
</template>

<script>
import layerMixin from './mixin';
import {createNamespacedHelpers} from "vuex";
import EditableTextElement from "@frontend/components/common/atoms/EditableTextElement.vue";
import {ApplyStrategy} from "@frontend/services/api/psd-layers";

const { mapGetters, mapActions } = createNamespacedHelpers('psdLayers')

export default {
  name: "TextLayer",
  components: {EditableTextElement},
  mixins: [layerMixin],
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'flow',
      'isSavingNodesChanges'
    ]),
    isLayerEditable() {
      return this.flow === ApplyStrategy.FLOWS.SAVE_TO_FILE_BROWSER;
    }
  },
}
</script>

<style scoped lang="scss">
.a-text-layer {
  font-size: 24px;
}
</style>
